import { FilterMatchMode } from "primereact/api";

export class ProveedorPj {
    constructor({ formularioMatriz } = {}) {
        this.formularioMatriz = formularioMatriz;

        this.model = {
            id: {
                export: true,
                header: 'Código',
                table: true,
                filter: true,
                filterPlaceholder: 'Buscar por código',
                filterField: 'id',
                sort: true,
                matchMode: FilterMatchMode.EQUALS,
                showFilterMatchModes: false,
                headerStyle: { width: '8%', minWidth: '10rem' }
            },
            fecha: {
                value: new Date(),
                export: true,
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
                table: true,
                filter: true, sort: true, isDate: true,
                headerStyle: { width: '12%', minWidth: '10rem' },
                body: (rowData) => {
                    if (!rowData.fecha) return null;
                    return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
                }
            },
            razon_social: {
                export: true,
                header: 'Razón Social',
                table: true,
                sort: true,
                filter: true,
                headerStyle: { width: '30%', minWidth: '20rem' },
                filterPlaceholder: 'Buscar Razón Social',
                filterField: 'razon_social',
                matchMode: FilterMatchMode.CONTAINS
            },
            nombre_comercial: {
                export: true,
                header: 'Nombre Comercial',
                table: true,
                sort: true,
                filter: true,
                headerStyle: { width: '25%', minWidth: '20rem' },
                filterPlaceholder: 'Buscar N. Comercial',
                filterField: 'nombre_comercial',
                matchMode: FilterMatchMode.CONTAINS
            },
            ruc: {
                export: true,
                header: 'RUC',
                filterPlaceholder: 'Buscar por RUC',
                filterField: 'ruc',
                matchMode: FilterMatchMode.CONTAINS,
                table: true,
                filter: true,
                sort: true,
                headerStyle: { width: '15%', minWidth: '15rem' }
            },
            estado_formulario: {
                value: null,
                export: true,
                header: 'Estado:',
                table: true,
                headerStyle: { width: '10%', minWidth: '12rem' },
                filter: true,
                filterPlaceholder: 'estado',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                matchMode: FilterMatchMode.CONTAINS
            },
            matriz: {
                value: null,
                export: true,
                header: 'Matriz:',
                table: formularioMatriz,
                headerStyle: { width: '10%', minWidth: '12rem' }, filter: false,
            },
        }
    }

    titulo = "Instrucciones de envío";

    pasosInstrucciones = [
        {
            titulo: "Paso 1",
            texto: <>Complete la información requerida en cada una de las secciones del formulario. Para guardar los avances y avanzar entre secciones, haga clic en el botón <b>"Siguiente"</b>. En la última sección del formulario, haga clic en el botón <b>"Guardar"</b> para consolidar la información registrada.</>
        },
        {
            titulo: "Paso 2",
            texto: <>Una vez guardada la información, haga clic en el botón <b>"Formulario"</b> para generar y descargar el documento en formato PDF, el cual debe ser impreso y firmado.</>
        },
        {
            titulo: "Paso 3",
            texto: <>El botón de <b>"Anexos"</b> se ubica en la última sección del formulario. Desde allí, adjunte el formulario principal firmado y todos los documentos de soporte requeridos.</>
        },
        {
            titulo: "Paso 4",
            texto: <>Una vez verificado que la información del formulario esté completa y que todos los anexos hayan sido cargados correctamente, haga clic en el botón <b>"Enviar"</b> para completar de manera exitosa el proceso.</>
        },
        {
            titulo: "Nota",
            texto: <>Los datos ingresados en el formulario pueden ser modificados en cualquier momento, siempre y cuando la información no haya sido <b>enviada</b> en el sistema.</>,
            isNote: true
        }
    ];
}